import { render, staticRenderFns } from "./ProductFreeShipping.vue?vue&type=template&id=314e6d6a"
import script from "./ProductFreeShipping.vue?vue&type=script&lang=js"
export * from "./ProductFreeShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports